<template>
  <div class="detail">
    <vannav />
    <div class="header">
      <i>
        <img :src="require('../assets/air/air.png')" alt="" />
      </i>
      <div class="mid">
        <p>{{ airData.branchName }}</p>
        <p>{{ airData.branchCode }}</p>
        <!--        <p>
									<span>
										<van-tag type="primary">{{
											airData.airOnOff == 1 ? "开机" : "关机"
										}}</van-tag>
									</span>
									<span
										>模式：<van-tag type="primary">
											{{
												airData.airMode == 1
													? "制冷"
													: airData.airMode == 2
													? "除湿"
													: airData.airMode == 3
													? "清爽"
													: airData.airMode == 4
													? "送风"
													: airData.airMode == 5
													? "自动除湿"
													: airData.airMode == 6
													? "贴心睡眠"
													: "制热"
											}}
										</van-tag></span
									>
									<span
										>温度：<van-tag type="primary">{{
											airData.airTemp ? airData.airTemp + "℃" : "0℃"
										}}</van-tag></span
									>
								</p>
								<p>
									<span>
										<van-tag type="primary">
											{{ airData.airFaultStatus == 0 ? "正常" : "异常" }}</van-tag
										>
									</span>
									<span
										>风速：<van-tag type="primary">{{
											airData.airSpeed == 0
												? "自动"
												: airData.airSpeed == 1
												? "高速"
												: airData.airSpeed == 2
												? "中速"
												: "低速"
										}}</van-tag></span
									>
									<span
										>室温：<van-tag type="primary">
											{{ airData.airRoomTemp + "℃" }}
										</van-tag></span
									>
								</p>-->
      </div>
      <van-switch
        :value="airData.airOnOff == 1 ? true : false"
        active-color="#1afa29"
        inactive-color="rgba(225, 225, 225, 1)"
        size="20px"
        @input="onInput()"
      />
    </div>
    <boxtop :calsstop="airStatus"></boxtop>
    <div class="airStatus">
      <div class="border_right">
        <span
          ><van-tag plain size="small" type="primary">
            {{
              airData.airMode == 1
                ? "制冷"
                : airData.airMode == 2
                ? "除湿"
                : airData.airMode == 3
                ? "清爽"
                : airData.airMode == 4
                ? "送风"
                : airData.airMode == 5
                ? "自动除湿"
                : airData.airMode == 6
                ? "贴心睡眠"
                : "制热"
            }}
          </van-tag></span
        >
        <span>模式</span>
      </div>
      <div class="border_right">
        <span
          ><van-tag plain size="small" type="primary">{{
            airData.airTemp ? airData.airTemp + "℃" : "0℃"
          }}</van-tag></span
        >
        <span>温度</span>
      </div>
      <div class="border_right">
        <span
          ><van-tag plain size="small" type="primary">{{
            airData.airSpeed == 0
              ? "自动"
              : airData.airSpeed == 1
              ? "高速"
              : airData.airSpeed == 2
              ? "中速"
              : "低速"
          }}</van-tag></span
        >
        <span>风速</span>
      </div>
      <div>
        <span
          ><van-tag plain size="small" type="primary">
            {{ airData.airRoomTemp + "℃" }}
          </van-tag></span
        >
        <span>室温</span>
      </div>
    </div>
    <boxtop :calsstop="calsstop"> </boxtop>

    <div class="tac">
      <div v-for="(item, index) in tag" :key="item.status">
        <!--        <van-button-->
        <!--          :color="item.color"-->
        <!--          round-->
        <!--          size="small"-->
        <!--          @click="statusType(index)"-->
        <!--        >-->
        <!--          {{ item.onOff }}-->
        <!--        </van-button>-->
        <span @click="statusType(index)">
          <img :src="item.url" alt="" />
        </span>
        <span :style="'color:' + item.color">{{ item.text }}</span>
      </div>
    </div>
    <boxtop :calsstop="calsstop1"></boxtop>
    <div class="tagSpeed">
      <div
        v-for="(item, index) in tagSpeed"
        :key="item.status"
        :class="item.className"
        @click="statusSpeed(index)"
      >
        <img :src="item.url" alt="" />
        <span>{{ item.text }}</span>
      </div>
    </div>
    <boxtop :calsstop="calsstop3"></boxtop>
    <div class="inpbox">
      <div>
        <div>温度设置</div>
        <div>
          <van-slider
            v-model="tempControl"
            :max="airData.airTempUpper"
            :min="airData.airTempLower"
            active-color="rgba(70, 122, 255, 1)"
            bar-height="5px"
            @change="setTemp"
          >
            <template #button>
              <div class="custom-button">{{ tempControl }}</div>
            </template>
          </van-slider>
        </div>
      </div>
      <!--      <div>
				<van-cell-group>
					<van-field
						v-model="airData.airTempUpper"
						disabled
						label="温度上限："
						type="number"
					/>
				</van-cell-group>
				<van-cell-group>
					<van-field
						v-model="airData.airTempLower"
						disabled
						label="温度下限："
						type="number"
					/>
				</van-cell-group>
			</div>-->
      <!--      <van-cell-group>
				<van-field
					v-model="tempControl"
					label="温度："
					placeholder="请设定温度值"
					type="digit"
					@blur="setTemp"
				/>
			</van-cell-group>-->

      <div class="submit">
        <van-button
          color="rgba(70, 122, 255, 1)"
          plain
          type="default"
          @click="getSaveAirOption(0)"
          >取消设置</van-button
        >
        <van-button
          color="rgba(70, 122, 255, 1)"
          type="primary"
          @click="getSaveAirOption(1)"
          >确认设置</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  AirDeviceDetail,
  deviceControl,
  saveAirOption,
} from "@/api/controlAir";
import { Dialog, Notify, Toast } from "vant";
import { checkData } from "../util/index";

export default {
  data() {
    return {
      checked: true,
      calsstop: {
        icon: "icon-a-iconkongtiao",
        title: "模式控制",
      },
      calsstop1: {
        icon: "icon-fengsu3",
        title: "风速控制",
      },
      calsstop3: {
        icon: "icon-wenduji",
        title: "温度控制",
      },
      airStatus: {
        title: "当前状态",
      },
      tag: [
        {
          status: 1,
          type: "success",
          color: "rgba(35, 39, 38, 0.4000)",
          url: require("../assets/air/tag1.png"),
          text: "制冷",
          onOff: "关闭",
        },
        {
          status: 2,
          type: "success",
          text: "除湿",
          color: "rgba(35, 39, 38, 0.4000)",
          url: require("../assets/air/tag2.png"),
          onOff: "关闭",
        },
        {
          status: 3,
          type: "success",
          text: "清爽",
          onOff: "关闭",
          color: "rgba(35, 39, 38, 0.4000)",
          url: require("../assets/air/tag3.png"),
        },
        {
          status: 4,
          type: "success",
          color: "rgba(35, 39, 38, 0.4000)",
          url: require("../assets/air/tag4.png"),
          text: "送风",
          onOff: "关闭",
        },
        {
          status: 5,
          type: "success",
          text: "自动除湿",
          color: "rgba(35, 39, 38, 0.4000)",
          url: require("../assets/air/tag5.png"),
          onOff: "关闭",
        },

        {
          status: 8,
          color: "rgba(35, 39, 38, 0.4000)",
          url: require("../assets/air/tag8.png"),
          type: "success",
          text: "制热",
          onOff: "关闭",
        },
        {
          status: 6,
          type: "success",
          text: "贴心睡眠",
          url: require("../assets/air/tag6.png"),
          color: "rgba(35, 39, 38, 0.4000)",
          onOff: "关闭",
        },
      ],

      tagSpeed: [
        {
          status: 0,
          text: "自动",
          onOff: "关闭",
          className: "",
          url: require("../assets/air/control/close0.png"),
        },
        {
          status: 1,
          text: "高速",
          onOff: "关闭",
          className: "",
          url: require("../assets/air/control/close1.png"),
        },
        {
          status: 2,
          text: "中速",
          onOff: "关闭",
          className: "",
          url: require("../assets/air/control/close2.png"),
        },
        {
          status: 4,
          text: "低速",
          onOff: "关闭",
          className: "",
          url: require("../assets/air/control/close4.png"),
        },
      ],
      timer: null,
      timer1: null,
      timer2: null,
      timer3: null,
      airData: {
        airRoomTemp: "00.000",
        airTemp: "00.000",
        airTempUpper: null,
        airTempLower: null,
      },
      value: [10, 20],
      modeControl: "",
      tempControl: null,
      speedControl: "",
      winddireControl: 0,
      // 数据回传更新列表
      airdetail: {
        changed: true,
        status: 1,
        modeControl: null,
        tempControl: null,
      },
    };
  },
  mounted() {
    this.AirDetail();
  },
  methods: {
    // 切换模式
    statusType(index) {
      if (this.airData.airOnOff == 0) {
        Notify({ type: "warning", message: "请打开空调操作" });
        return;
      }
      this.tag.map((item) => {
        item.color = "rgba(35, 39, 38, 0.4000)";
        item.url = require("../assets/air/tag" + item.status + ".png");
        return item;
      });
      this.tag[index].color = "rgba(35, 39, 38, 1)";
      this.tag[index].url = require("../assets/air/tagTrue" +
        this.tag[index].status +
        ".png");
      this.modeControl = this.tag[index].status;
      // let conVal = this.modeControl;
      // modeAirOption(
      //   conVal,
      //   this.airData.collectorSerial,
      //   this.airData.deviceType,
      //   this.airData.branchCode,
      //   this.airData.branchId,
      //   this.airData.subStr
      // )
      //   .then(res => {
      //     if (res.data.data.result == "success") {
      //       this.airData.airMode = this.modeControl;
      //       Toast.success("加载成功");
      //     } else {
      //       Toast.fail("加载失败");
      //     }
      //   })
      //   .catch(err => {
      //     Notify({ type: "warning", message: "服务器错误" });
      //   });
    },
    // 切换风速
    statusSpeed(index) {
      if (this.airData.airOnOff == 0) {
        Notify({ type: "warning", message: "请打开空调操作" });
        return;
      }
      this.tagSpeed.map((item) => {
        item.onOff = "关闭";
        item.url = require("../assets/air/control/close" +
          item.status +
          ".png");
        item.className = "";
        return item;
      });
      this.tagSpeed[index].onOff = "开启";
      this.tagSpeed[index].className = "active";
      this.tagSpeed[index].url = require("../assets/air/control/open" +
        this.tagSpeed[index].status +
        ".png");
      this.speedControl = this.tagSpeed[index].status;
      // let conVal = this.speedControl;
      // speedAirOption(
      //   conVal,
      //   this.airData.collectorSerial,
      //   this.airData.deviceType,
      //   this.airData.branchCode,
      //   this.airData.branchId,
      //   this.airData.subStr
      // )
      //   .then(res => {
      //     if (res.data.data.result == "success") {
      //       Toast.loading({
      //         message: "加载中...",
      //         forbidClick: true
      //       });
      //       this.airData.airSpeed = this.speedControl;
      //       Toast.success("加载成功");
      //     } else {
      //       Toast.fail("加载失败");
      //     }
      //   })
      //   .catch(err => {
      //     Notify({ type: "warning", message: "服务器错误" });
      //   });
    },
    // 详情
    AirDetail() {
      AirDeviceDetail(this.$route.query.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.airData = res.data.data;

            !checkData(res.data.data.airRoomTemp)
              ? (this.airData.airRoomTemp = 0)
              : null;
            this.tempControl = Number(this.airData.airTemp);
            this.value = [
              Number(this.airData.airTempLower),
              Number(this.airData.airTempUpper),
            ];
            console.log(this.value);
            this.tag = this.tag.map((item) => {
              if (item.status == this.airData.airMode) {
                item.onOff = "开启";
                item.color = "rgba(35, 39, 38, 1)";
                item.url = require("../assets/air/tagTrue" +
                  item.status +
                  ".png");
                this.modeControl = item.status;
              }
              return item;
            });
            this.tagSpeed = this.tagSpeed.map((item) => {
              if (item.status == this.airData.airSpeed) {
                item.onOff = "开启";
                item.url = require("../assets/air/control/open" +
                  item.status +
                  ".png");
                item.className = "active";
                this.speedControl = item.status;
              }
              return item;
            });

            Toast.success("加载成功");
          } else {
            Toast.fail("加载失败");
          }
        })
        .catch((err) => {
          Notify({ type: "warning", message: "服务器错误" });
        });
    },
    onChange(value) {
      Toast("当前值：" + value);
    },
    // 设置温度
    setTemp() {
      clearTimeout(this.timer);
      clearTimeout(this.timer1);
      if (this.airData.airOnOff == 0) {
        Notify({ type: "warning", message: "请打开空调操作" });
        return;
      }
      if (
        this.tempControl < this.airData.airTempLower ||
        this.tempControl > this.airData.airTempUpper ||
        this.tempControl == null
      ) {
        this.tempControl = null;
        Toast.fail("设置有效值");
      } else {
        this.timer1 = setTimeout(() => {
          Toast.loading({
            message: "加载中...",
            forbidClick: true,
          });
        }, 1000);
        this.timer = setTimeout(() => {
          // let conVal = this.tempControl;
          // tempAirOption(
          //   conVal,
          //   this.airData.collectorSerial,
          //   this.airData.deviceType,
          //   this.airData.branchCode,
          //   this.airData.branchId,
          //   this.airData.subStr
          // )
          //   .then(res => {
          //     if (res.data.data.result == "success") {
          Toast.success("加载成功");
          //   } else {
          //     Toast.fail("加载失败");
          //   }
          // })
          // .catch(err => {
          //   Notify({ type: "warning", message: "服务器错误" });
          // });
        }, 1000);
      }
    },
    // 保存设置
    getSaveAirOption(params) {
      clearTimeout(this.timer2);
      if (params === 0) {
        this.tagSpeed.map((item) => {
          item.onOff = "关闭";
          item.color = "rgba(35, 39, 38, 0.6000)";
          item.url = require("../assets/air/control/close" +
            item.status +
            ".png");
          item.className = "";
          return item;
        });

        this.tag.map((item) => {
          item.color = "rgba(35, 39, 38, 0.4000)";
          item.url = require("../assets/air/tag" + item.status + ".png");
          item.onOff = "关闭";
          return item;
        });
        this.tempControl = Number(this.airData.airTempLower);
        this.speedControl = null;
        this.modeControl = null;
      }
      if (params === 1) {
        if (this.airData.airOnOff === 0) {
          Notify({ type: "warning", message: "请打开空调操作" });
          return;
        }
        saveAirOption(
          this.modeControl,
          this.tempControl,
          this.speedControl,
          this.winddireControl,
          this.airData.collectorSerial,
          this.airData.deviceType,
          this.airData.branchCode,
          this.airData.branchId,
          this.airData.subStr
        )
          .then((res) => {
            this.timer2 = setTimeout(() => {
              if (res.data.data.result === "success") {
                Toast.loading({
                  message: "加载中...",
                  forbidClick: true,
                });
                this.airData.airTemp = this.tempControl;
                this.airData.airMode = this.modeControl;
                this.airData.airSpeed = this.speedControl;
                this.airdetail = {
                  changed: true,
                  status: this.airData.airOnOff,
                  modeControl: this.modeControl,
                  tempControl: this.tempControl,
                };
                this.$store.commit("changeAirdetail", this.airdetail);
                Toast.success("加载成功");
              } else {
                Toast.fail("加载失败");
              }
            }, 2000);
          })
          .catch((err) => {
            Notify({ type: "warning", message: "服务器错误" });
          });
      }
    },
    // 打开
    onInput() {
      clearTimeout(this.timer3);
      Dialog.confirm({
        title: "提醒",
        message: "是否切换开关？",
      })
        .then(() => {
          deviceControl(
            this.airData.airOnOff === 0 ? 1 : 0,
            this.airData.collectorSerial,
            this.airData.deviceType,
            this.airData.branchCode,
            this.airData.branchId,
            this.airData.subStr
          )
            .then((res) => {
              this.timer3 = setTimeout(() => {
                Toast.loading({
                  message: "加载中...",
                  forbidClick: true,
                });
                if (res.data.data.result === "success") {
                  this.airData.airOnOff == 0
                    ? (this.airData.airOnOff = 1)
                    : (this.airData.airOnOff = 0),
                    Toast.success("操作成功");
                  this.airdetail = {
                    changed: true,
                    status: this.airData.airOnOff,
                    modeControl: this.modeControl,
                    tempControl: this.tempControl,
                  };
                  this.$store.commit("changeAirdetail", this.airdetail);
                } else {
                  Toast.fail("操作失败");
                }
              }, 2000);
            })
            .catch((err) => {
              Notify({ type: "warning", message: "服务器错误" });
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.detail {
  background-color: rgba(246, 248, 255, 1);
}

.header {
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;
  background-color: #ffffff;
  height: 80px;

  & > i {
    width: 40px;
    height: 40px;

    & > img {
      width: 100%;
      height: auto;
    }
  }

  & > .mid {
    height: 100%;
    text-align: left;
    flex: 1;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    line-height: 30px;

    & > p {
      &:first-child {
        font-size: 20px;

        font-weight: bold;
      }
    }
  }
}

.airStatus {
  margin-bottom: 10px;
  padding-bottom: 10px;
  width: 100%;
  background-color: #ffffff;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .van-tag {
    border: 1px solid #a3beff;
  }

  & > div {
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    position: relative;

    & > span:first-child {
      line-height: 30px;
    }

    & > span:last-child {
      font-size: 12px;
      color: #a9a9a9;
    }

    &.border_right:before {
      content: "";
      position: absolute;
      left: 100%;
      top: 28%;
      width: 1px;
      height: 50%;
      background-color: #cccccc;
    }
  }
}

.tac {
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  background-color: #ffffff;
  margin-bottom: 10px;

  & > div {
    display: flex;
    width: 25%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    & > span:last-child {
      margin-bottom: 20px;
    }

    & > span:first-child {
      & > img {
        width: 50px;
        height: 50px;
      }
    }
  }
}

.tagSpeed {
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  background-color: #ffffff;
  margin-bottom: 10px;

  & > div {
    cursor: pointer;
    flex: 1;
    height: 30px;
    margin: 0 10px;
    border-radius: 3px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 5px;
    background-color: #ffffff;
    box-shadow: 0 0 2px 2px #e5e2e2ff;
    color: rgba(35, 39, 38, 0.6);

    &.active {
      color: #ffffff;
      box-shadow: 0 0 2px 2px rgba(70, 122, 255, 0.2);
      background-color: rgba(70, 122, 255, 1);
    }

    img {
      width: 20px;
      height: 20px;
    }
  }
}

.inpbox {
  margin: 5px auto auto;
  background-color: #ffffff;

  & > div {
    width: 100%;

    &:first-child {
      padding: 15px 15px 15px 16px;
      box-sizing: border-box;
      width: 95%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      & > div:last-child {
        flex: 1;
        margin-top: 10px;
        margin-left: 20px;
      }
    }

    .van-slider {
      margin-bottom: 10px;
    }
  }

  .van-cell-group,
  .van-slider {
    border-bottom: 1px solid rgba(236, 236, 236, 0.767);
  }
}

.submit {
  margin: 15px 0;
  display: flex;
  justify-content: space-around;

  .van-button {
    flex: 1;
    margin: 0 10px;
    border-radius: 5px;
    letter-spacing: 4px;
  }
}

.van-switch {
  z-index: 0;
}

.custom-button {
  width: 20px;
  color: rgba(35, 39, 38, 0.8);
  font-size: 10px;
  line-height: 18px;
  text-align: center;
  background-color: #ffffff;
  border-radius: 100px;
  border: 4px solid rgba(70, 122, 255, 1);
}
</style>
